import { IncError } from "@core/domain/errors/inc.error";
import i18n from "@i18n";

export class StatutoryTerritorialMapperError extends IncError {
    constructor() {
        super(i18n.t("error:entity.statutoryTerritorialScope.statutoryTerritorialScopeMapperError"));

        Object.setPrototypeOf(this, StatutoryTerritorialMapperError.prototype);
    }
}